package app.nestbridge.domain.identity.api.model

import kotlinx.serialization.Serializable

@Serializable
enum class ProfessionalServiceTypeDto(
    val label: String,
) {
    SpeechLanguageTherapy("Speech-Language Therapy (SLP)"),
    OccupationalTherapy("Occupational Therapy (OT)"),
    PhysicalTherapy("Physical Therapy (PT)"),
    DevelopmentalTherapy("Developmental Therapy / Special Instruction"),
    AppliedBehaviorAnalysis("Applied Behavior Analysis (ABA)"),
    FeedingTherapy("Feeding Therapy"),
    MentalHealthCounseling("Mental Health / Counseling"),
    Psychology("Psychology"),
    SocialWork("Social Work"),
    EarlyChildhoodEducation("Early Childhood Education / Special Education"),
    VisionServices("Vision Services"),
    HearingAudiology("Hearing / Audiology"),
    Other("Other"),
}
